import { VGB_VISIBILITY_CHANGED_EVENT } from './StudioEvents';
import { SHOW_VIRTUAL_GLYCOL_BUFFER_TEMPERATURES } from './StudioProfileService';

interface StudioProfileServiceLike {
    get(key: string): unknown;
    set(key: string, value: unknown): Promise<void>;
}

interface RootScopeLike {
    $broadcast(name: string): void;
}

export default class VirtualGlycolBufferTemperatureVisibilityService {
    // declare: type-only, erased by tsc — real class fields break this project's webpack setup
    declare static $inject: string[];

    declare private StudioProfileService: StudioProfileServiceLike;

    declare private $rootScope: RootScopeLike;

    constructor(StudioProfileService: StudioProfileServiceLike, $rootScope: RootScopeLike) {
        this.StudioProfileService = StudioProfileService;
        this.$rootScope = $rootScope;
    }

    get showTemperatures(): boolean {
        return Boolean(this.StudioProfileService.get(SHOW_VIRTUAL_GLYCOL_BUFFER_TEMPERATURES));
    }

    // Save on every call without checking the cached value first. Resolves once saved, rejects on failure.
    setShowTemperatures(value: boolean): Promise<void> {
        return this.StudioProfileService.set(SHOW_VIRTUAL_GLYCOL_BUFFER_TEMPERATURES, Boolean(value))
            .then(() => this.notifyChanged());
    }

    // Broadcast so views that draw imperatively (the dashboard's charts) can redraw.
    notifyChanged(): void {
        this.$rootScope.$broadcast(VGB_VISIBILITY_CHANGED_EVENT);
    }
}

VirtualGlycolBufferTemperatureVisibilityService.$inject = ['StudioProfileService', '$rootScope'];
